exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".NoResults-root-7EUbV {\n    margin: 60px 20px 0;\n    text-align: center;\n}\n\n.NoResults-container-earh- {\n    margin: 64px 40px 96px;\n}\n\n.NoResults-noHeading-SFJYl {\n    font-size: 20px;\n    margin-top: 20px;\n}\n\n.NoResults-noSubHeading-k9xcB {\n    font-size: 18px;\n    margin: 10px 0 0;\n    color: #707070;\n}", ""]);

// exports
exports.locals = {
	"root": "NoResults-root-7EUbV",
	"container": "NoResults-container-earh-",
	"noHeading": "NoResults-noHeading-SFJYl",
	"noSubHeading": "NoResults-noSubHeading-k9xcB"
};